import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Programs", href: "#programs" },
  { label: "Housing", href: "#housing" },
  { label: "How to Apply", href: "#apply" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`sticky top-0 z-50 bg-[#F9F9F8] border-b-2 border-[#0F0F0F]/10 transition-shadow ${scrolled ? "shadow-md" : ""}`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between h-20">
        <a href="#home" data-testid="nav-logo" className="flex items-center group">
          <img src="/make-room-logo.png" alt="Make Room Independent Living" className="h-12 md:h-14 w-auto" />
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-medium text-[#0F0F0F] hover:text-[#4A4A4A] relative after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-[#FFC000] hover:after:w-full after:transition-all"
            >
              {l.label}
            </a>
          ))}
          <a href="#apply" data-testid="nav-apply-btn" className="btn-brutal text-sm">Apply Now</a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 border-2 border-[#0F0F0F]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#F9F9F8] border-t-2 border-[#0F0F0F]/10 px-5 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="font-medium py-1">{l.label}</a>
          ))}
          <a href="#apply" onClick={() => setOpen(false)} className="btn-brutal justify-center">Apply Now</a>
        </div>
      )}
    </nav>
  );
};
